export default "__VITE_ASSET__DuZmn3yS__"